import { useEffect } from "react";
import analyticsInstance from "../AnalyticsSingleton";
export var useAnalytics = function(name, value) {
    useEffect(function() {
        analyticsInstance.track(name, value);
    }, [
        name,
        value
    ]);
};

//# sourceMappingURL=index.js.map